import { defineNuxtRouteMiddleware, navigateTo, useRouter } from '#imports'
import { clearApiCache } from '~/utils/cache'
import useAuthStore from '~/stores/auth'

const routeSavedHeight = new Map<string | symbol, number>()

export default defineNuxtRouteMiddleware(async (to, from) => {
  const { isAuthenticated, acquireSession } = useAuthStore()
  const router = useRouter()

  if (from.name && (from.name !== to.name)) {
    routeSavedHeight.set(from.name, document.body.scrollHeight)
  }

  if (from.name === 'my_content_reports') {
    to.meta.reportReturnPath = from.fullPath
  }

  if (['login', 'register', 'activate', 'oidc', 'callback', 'vipps'].includes(to.name as string)) {
    await clearApiCache()
    return
  }

  if (from.meta.isNavigation) { // Set new returnPath to a navigation view
    to.meta.returnPath = from.fullPath
  } else if (from.meta.returnPath) { // Keep previous returnPath
    to.meta.returnPath = from.meta.returnPath
  }

  try {
    if (!isAuthenticated)
      await acquireSession(router)
  } catch {
    await clearApiCache()

    if (to.meta.preview) {
      return
    }

    return navigateTo({
      name: 'login',
      query: { 'tilbake-til': window.location.pathname + window.location.search },
    })
  }
})
